<script>
    import FeatureTrack from './FeatureTrack.svelte';

    export let featureData;
    export let section;
    import { slide, blur } from 'svelte/transition';
    import tippy from "sveltejs-tippy";
    console.log("featureData", featureData);
    console.log("section", section);

    let basicFeats = [];
    let advFeats = [];

    basicFeats = [];
    advFeats = [];
    for (let item of section[1]) {
        if (item[3] == "basic") {
            basicFeats.push(item);
        }
        else if (item[3] == "adv") {
            advFeats.push(item);
        }
    }

</script>

<style>
    .basic {
        border: 0.15rem black solid;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        position: relative;
        left: -0.15rem;
        margin-right: -0.3rem;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
    }
    summary {
        text-transform: uppercase;
        font-weight: bold;
        margin-left: 2rem;
        cursor: pointer;
        letter-spacing: 0.05em;
        margin-bottom: 0.5rem;
    }
</style>

<div class="tracks">
    <div class="basic lev1 dark">
        {#each basicFeats as feat}
            <FeatureTrack {feat} bind:featureData />
        {/each}
    </div>
    <details>
        <summary>
            <span use:tippy="{{content: 'Show more phonetic features'}}">
                Advanced&nbsp;<div class="help">&nbsp;</div>&nbsp;</span>
        </summary>
        {#each advFeats as feat}
            <FeatureTrack {feat} bind:featureData />
        {/each}
    </details>
</div>